import * as React from 'react';
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {ICacheManager, ICustomerPortalService, Types, NEW_PAYMENT, PaymentCard} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {Navigate} from "react-router-dom";
import {setSessionStorage} from "../../../../CommonFunctions";

interface IStartPaymentPageParams {
    policyNumber: string
    [key: string]: string | undefined
}

interface IState {
    party: PaymentCard | null,
}

@authorize
export class StartPaymentPagePlain extends React.Component<IWithRouterProps<IStartPaymentPageParams>, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps<IStartPaymentPageParams>) {
        super(props);
        this.state = {
            party: null
        };
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Start payment");
        this.cacheManager.clearCache("getAnnualPolicyInfo");
        this.customerPortalService.getMainPaymentCard(this.props.params.policyNumber).subscribe((output: PaymentCard) => {
            this.setState({
                party: output
            })
        });
        setSessionStorage("paymentSettings", this.props.location.state);
        setSessionStorage("referrerJourney", NEW_PAYMENT);
    }

    public render() {
        if (this.state.party) {
            if (this.state.party.reuseCard) {
                return <Navigate to={{pathname: `/dashboard/account/existingCardPayment/${this.props.params.policyNumber}`}}/>
            } else {
                return <Navigate to={{pathname: `/dashboard/account/newCardPayment/${this.props.params.policyNumber}`}}/>
            }
        }
        return (
            <React.Fragment>
                <FalconHeader/>
                    <Overlay show={true}/>
                <FalconFooter/>
            </React.Fragment>
        )
    }
}

export const StartPaymentPage = withRouter<{}, IStartPaymentPageParams>(StartPaymentPagePlain)
